<template>
  <div class="day-image-card">
    <div class="day-image-card__header">
      <b><font face="微软夜黑" style="font-size: 18pt" color="#FFFFFF">{{ title }}</font></b>
    </div>
    <div v-if="showDayButtons" class="day-image-card__row">
      <button
        v-for="d in dayRange"
        :key="d"
        type="button"
        class="day-image-card__btn"
        :class="{ 'is-selected': d === selectedDay }"
        @click="selectDay(d)"
      >{{ d }}期</button>
    </div>
    <div v-for="(s, i) in displaySrcs" :key="i" class="day-image-card__img-wrap">
      <img :src="s" class="day-image-card__img" alt="" />
      <div v-if="showYearCover" class="day-image-card__year-cover"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DayImageCard',
  props: {
    urls: { type: Array, default: () => [] },
    start: { type: Number, default: 0 },
    end: { type: Number, default: undefined },
    title: { type: String, default: '每日看图' },
    range: { type: Number, default: 20 },
    showDayButtons: { type: Boolean, default: true },
    showYearCover: { type: Boolean, default: true }
  },
  data() {
    return {
      selectedDay: null
    }
  },
  computed: {
    year() {
      return new Date().getFullYear()
    },
    todayDayOfYear() {
      const now = new Date()
      const start = new Date(this.year, 0, 1)
      return Math.floor((now - start) / 86400000) + 1
    },
    dayRange() {
      const start = Math.max(1, this.todayDayOfYear - this.range + 1)
      const end = this.todayDayOfYear
      const arr = []
      for (let d = end; d >= start; d--) arr.push(d)
      return arr
    },
    displayUrls() {
      const list = Array.isArray(this.urls) ? this.urls : []
      return list.slice(this.start, this.end).map(u => (
        typeof u === 'string' ? u : (u.src || '')
      ))
    },
    displaySrcs() {
      const d = this.selectedDay
      return this.displayUrls.map(u => {
        const base = String(u || '').trim()
        if (!base || d == null) return base
        return base.replace(/\/col\/\d+(?=\/)/, `/col/${d}`)
      })
    }
  },
  watch: {
    urls() {
      this.selectedDay = this.dayRange.length ? this.dayRange[0] : null
    }
  },
  mounted() {
    this.selectedDay = this.dayRange.length ? this.dayRange[0] : null
  },
  methods: {
    selectDay(d) {
      this.selectedDay = d
      this.$emit('day-select', d)
    }
  }
}
</script>

<style scoped>
.day-image-card {
  margin: 0.5rem 0;
  background: #fff;
  border: 1px solid #000000;
  box-shadow: 0 2px 8px rgba(30, 107, 214, 0.08);
  overflow: hidden;
}
.day-image-card__header {
  border: 8px double #ff9900;
  background: #009900;
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.day-image-card__row {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  gap: 0.25rem;
  padding: 0.4rem 0.5rem;
}
.day-image-card__btn {
  flex: 0 0 auto;
  min-width: 2.6rem;
  border: 1px solid #cbd5e0;
  background: #f7fafc;
  color: #2d3748;
  border-radius: 4px;
  font-size: 1rem;
  line-height: 1.5;
  padding: 0.25rem 0.5rem;
  cursor: pointer;
}
.day-image-card__btn.is-selected {
  background: #1e6bd6;
  border-color: #1e6bd6;
  color: #fff;
  font-weight: 700;
}
.day-image-card__img {
  display: block;
  width: 100%;
  height: auto;
}
.day-image-card__img-wrap {
  position: relative;
}
.day-image-card__year-cover {
  position: absolute;
  left: 23.2%;
  top: 3.95%;
  width: 11%;
  height: 3.1%;
  background: rgb(84, 200, 250);
  pointer-events: none;
}
</style>
